import { ChangeEvent, FocusEvent } from "react";
import styles from "./ControlledRadio.module.scss";

export interface ControlledRadioProps {
  /**
   *  To style ControlledRadio
   */
  className?: string;
  /**
   *  To style ControlledRadio Label
   */
  labelClassName?: string;
  /**
   *  The ControlledRadio's label
   */
  label: string;
  /**
   *  The ControlledRadio's value
   */
  value: string;
  /**
   *  The ControlledRadio's name
   */
  name: string;
  /**
   *  To select one item
   */
  checked: boolean;
  /**
   *  Handler called when the ControlledRadio's item selected changes.
   */
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  /**
   *  Disabled option.
   */
  disabled?: boolean;
  /**
   *  Handler called when the ControlledRadio's item loses focus.
   */
  onBlur?: (event: FocusEvent<HTMLInputElement, Element>) => void;
  onClick?: () => void;
}

/**
 *  Allow users to select a single item
 */
const ControlledRadio = ({
  className,
  label,
  value,
  name,
  checked,
  onChange,
  disabled,
  onBlur,
  labelClassName,
}: ControlledRadioProps) => {
  const { inputRadio, radioLabel, labelDisabled } = styles;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(event);
  };

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    onBlur && onBlur(event);
  };

  return (
    <label
      className={`${radioLabel} ${disabled ? labelDisabled : ""} ${labelClassName}`}
    >
      <input
        type="radio"
        value={value}
        name={name}
        checked={checked}
        className={`${inputRadio} ${className ?? ""}`}
        disabled={disabled}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      {label}
    </label>
  );
};

export default ControlledRadio;
